import { ResetPasswordPage } from './reset-password.page';

export const PAGES = [ResetPasswordPage];

export {
  ResetPasswordPage
};



// WEBPACK FOOTER //
// ./src/app/auth/pages/index.ts